import React from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { editPin, getPin } from "../../actions/pins";
import { Editor } from "@tinymce/tinymce-react";

const TinyMCE_Key = process.env.REACT_APP_TINY_MCE_KEY;

const stripEmptyHtml = (html) => {
  if (!html) return "";
  const stripped = html.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").trim();
  return stripped === "" ? "" : html;
};

function ContributePanel({ pin, user, onCancel }) {
  const [contribText, setContribText] = React.useState(pin && pin.description ? pin.description : "");
  const [summary, setSummary] = React.useState("");
  const dispatch = useDispatch();
  const editorRef = React.useRef(null);

  return (
    <div style={{ padding: "8px 0" }}>
      <Editor
        apiKey={TinyMCE_Key}
        onInit={(evt, editor) => {
          editorRef.current = editor;
        }}
        content={contribText}
        onChange={(e) => setContribText(stripEmptyHtml(e.target.getContent()))}
        init={{
          init_instance_callback: (editor) => {
            editor.setContent(contribText || "");
          },
          height: 300,
          menubar: false,
          plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste code help wordcount emoticons",
          ],
          toolbar: "undo redo | bold italic emoticons | link image | help ",
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px } .img-responsive { height: auto; width: 100%; }",
          image_dimensions: false,
          image_class_list: [{ title: "img-responsive", value: "img-responsive" }],
        }}
      />
      <input
        value={summary}
        onChange={(e) => setSummary(e.target.value)}
        placeholder={"Describe your revision (optional)"}
        style={{ width: "100%", marginTop: "8px", padding: "6px" }}
      />
      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "8px", gap: "8px" }}>
        <Button variant="outline-secondary" size="sm" style={{ borderRadius: '8px', textTransform: 'lowercase' }} onClick={() => { if (onCancel) onCancel(); }}>
          cancel
        </Button>
        <Button
          className="btn btn-primary btn-sm default-btn-purple"
          disabled={!stripEmptyHtml(contribText)}
          onClick={() => {
            const payload = { description: stripEmptyHtml(contribText), summary: summary };
            dispatch(editPin(payload, pin.id, user && user.id))
              .then(() => {
                setSummary("");
                // keep contrib text prefilled with updated description
                dispatch(getPin(pin.id, user && user.id));
                if (onCancel) onCancel();
              })
              .catch((err) => console.log(err));
          }}
        >
          Submit edit
        </Button>
      </div>
    </div>
  );
}

export default ContributePanel;
